import React from "react";
import styled from "styled-components";
import pick from "lodash/pick";

import * as u from "../../utils";
import * as gtag from "../../utils/gtag";
import EventCollection from "../../components/EventCollection";
import EventVideoCard from "../../components/EventVideoCard";
import RxSubNavEvents from "../../components/ui/navigation/RxSubNavEvents";

export default function Events(props) {
  const initialListSize = 8;

  return (
    <>
      <RxSubNavEvents data-cy="events-subnav" />
      <S.Container data-cy="s-container">
        <EventCollection
          initialListSize={initialListSize}
          datacy="event-collection"
        >
          {getRecordedEvents(props.events).map(
            getRecordedEvent(initialListSize)
          )}
        </EventCollection>
      </S.Container>
    </>
  );

  function getRecordedEvents(events) {
    let copy = [...events];
    copy = copy.sort(newestFirst);
    return copy;

    function newestFirst(a, b) {
      return b.startTime - a.startTime;
    }
  }

  function getRecordedEvent(initialListSize) {
    return (props, index) => {
      const subProps = {
        key: index,
        index: index,
        initialListSize: initialListSize,
        ...props,
      };

      return <EventVideoCard {...subProps} onClick={onClick} />;

      function onClick() {
        gtag.event({
          name: gtag.GA_EVENT.EVENT_ENGAGEMENT,
          category: "Events",
          value: "From On-Demand",
        });
      }
    };
  }
}

export async function getStaticProps() {
  const firebase = require("../../firebase.admin");
  const eventsRef = firebase
    .firestore()
    .collection("events")
    .where("recordedEventVideoUrl", "!=", "");
  const events = (await eventsRef.get()).docs.map((doc) =>
    pick(doc.data(), [
      "cardImage",
      "endTime",
      "exclusiveGroups",
      "id",
      "isFree",
      "location",
      "memberAccess",
      "recordedEventVideoUrl",
      "startTime",
      "tags",
      "title",
    ])
  );

  return { props: { events }, revalidate: 3600 };
}

const S = {};

S.Container = styled.div`
  max-width: 1440px;
  margin: auto;
  padding: 20px 16px;

  @media ${u.device.tablet} {
    padding: 20px;
  }

  @media ${u.device.desktop} {
    padding: 40px;
  }
`;
